export const BLOCK_TYPE_COLLAPSIBLE_CONTENT = 'collapsible-content';
